import 'flatpickr';
import 'dateformat'

export default {
  init(selector, config) {

  },
  finalize() {

    const duration = courseinfo['course_duration'];
    const int_cost = courseinfo['international_cost'];

    $("#startDateCalendar").flatpickr({
      altInput: true,
      altFormat: "D J M Y",
      dateFormat: "Y-m-d",
      minDate: "today",
      maxDate: new Date().fp_incr(60),
      defaultDate: "today",
    });

    // Choose start now
    $("#startNowRadio").on('click', function () {
      $('.u-datepicker').hide();
      $("#startNowDisplay").hide();
      
      // Get the current date and apply human friendly format
      const dateFormat = require('dateformat');
      const newDate = new Date();
      const newEndDate = new Date();
      newEndDate.setDate(newEndDate.getDate() + (7 * duration)); // Add  days
      const startNow = dateFormat(newDate, "ddd d mmm yyyy");
      const endDate = dateFormat(newEndDate, "ddd d mmm yyyy");
      const endDateInput = dateFormat(newEndDate, "yyyy-mm-dd");
      // update the start and end dates
      $("span.start_date").html(startNow);
      $("span.end_date").html(endDate);
      $('#endDateInput').val(endDateInput);
      $("span.start_date_display").html(startNow);

      // reset the startdate input to today
      $("#startDateCalendar").flatpickr({
        altInput: true,
        altFormat: "D J M Y",
        dateFormat: "Y-m-d",
        minDate: "today",
        maxDate: new Date().fp_incr(60),
        defaultDate: "today",
      });
      $("#mainDateDiv").removeClass('d-none'); // BIZ-1154: Remove d-none class
      $("#startNowDisplay").show('slow');
      $("#listItemStartDate").show('slow');
      $("#listItemCompletionTime").show('slow');
    });

    // Choose start later
    $("#startLaterRadio").on('click', function () {
      $("#startDateCalendar").val('');
      $("#mainDateDiv").addClass('d-none'); // BIZ-1154: if select start later add d-none class
      $("#listItemStartDate").hide();
      $("#listItemCompletionTime").hide();
      $("#startNowDisplay").hide();
      $("#startLaterRadio").removeClass('is-checked');
      $("#startDateCalendar").flatpickr({
        altInput: true,
        altFormat: "D J M Y",
        dateFormat: "Y-m-d",
        minDate: new Date().fp_incr(1),
        maxDate: new Date().fp_incr(60),

        onClose: function (selectedDates, dateStr, instance) {
          if (instance.isMobile) {
            $('form input[type="date"][step="any"]').removeAttr('step');
          }

          const dateFormat = require('dateformat');
          const newDate = new Date(dateStr);
          const newEndDate = new Date(dateStr);
          newEndDate.setDate(newEndDate.getDate() + 7 * duration); // Add  days
          const startLater = dateFormat(newDate, "ddd d mmm yyyy");
          const endLater = dateFormat(newEndDate, "ddd d mmm yyyy");
          const endLaterInput = dateFormat(newEndDate, "yyyy-mm-dd");

          $("span.start_date").html(startLater);
          $("span.end_date").html(endLater);
          $('#endDateInput').val(endLaterInput);
          $("span.start_date_display").html(startLater);
          $("#mainDateDiv").removeClass('d-none'); // BIZ-1154: Remove d-none class
          $("#startNowDisplay").show('slow');
          $("#listItemStartDate").show('slow');
          $("#listItemCompletionTime").show('slow');
        }
      });
      $('.u-datepicker').show('slow');
    });

    // Step one next button
    $("#stepOneButton").on('click', function () {
      // check if start now is selected and value is empty before showing start and completion date and next part of form
      if ($("#startLaterRadio").is(":checked") && $("#startDateCalendar").val() == '') return;
      $("#mainDateDiv").removeClass('d-none'); // BIZ-1154: Remove d-none class
      $("#listItemStartDate").show('slow');
      $("#listItemCompletionTime").show('slow');
      $('#selectStepOne').hide();
      $('#selectStepThree').show();
    });

    // Step two back button
    $("#stepTwoButtonBack").on('click', function () {
      $("#listItemCost").hide();
    });

    // Choose International Access
    $("#intLocationRadio").on('click', function () {
      $(".course_cost").html(int_cost);
      $(".cost_info").html('for International Students');
      $(".cost_currency").html('AUD');
      $("#locationNextBut").data("next-step", "#selectStepPayment");
    });

    // Choose Local Access
    $("#ausLocationRadio").on('click', function () {
      $(".course_cost").html('Free');
      $(".cost_info").html('for Australian Care Workers and Practitioners');
      $(".cost_currency").html('');
      $("#locationNextBut").data("next-step", "#selectStepThree");
    });

    if ($('#startLaterRadio').hasClass("is-checked")) {
      $("#startLaterRadio").click();
    }

    const occupation_value = $('#occupation').val();
    if(occupation_value == 'other (occupation not listed)'){
      $(".occupation_others_div").removeClass('d-none');
    }
    //  occupation change events
    $('#occupation').on('change', function () { 
      const occupation_value = $(this).val(); // get the dropdown value
      $(".occupation_others_div").addClass('d-none'); // by default others field hide
      //BIZ_823 START: Making occupation_others element null only if profilevalidation
      var profileValidationClick = $(".profileValidation");
      if(!profileValidationClick.data('clicked')) {
        $("#occupation_others").val('');
      }
      //BIZ_823 START: Making occupation_others element null only if profilevalidation
      if(occupation_value == 'other (occupation not listed)'){
          $(".occupation_others_div").removeClass('d-none');
      }
    });

    /* BIZ-621 If User wants to enable last enrolment */
    $(".undelete-course").on("click", function () {
      var enrolment_id = $(this).data("enrolment-id");
      var url = ajaxdta.ajaxurl + "?action=process_undelete_enrolment";

      $(this).html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Restore Previous'); //show loader
      $(this).attr('disabled', 'disabled'); // Disable button
      $(this).off('click'); // Disable click events

      $.ajax({
        type: "POST",
        url: url,
        data: {
          enrolment_id: enrolment_id
        },
        dataType:"JSON",

         // Hide stuff and show dropDownNotice
         beforeSend: function () {
          $("html, body").animate({scrollTop: 0}, 'slow');
          $("#loading_button").show();
        },

        success: function (response) { 

          $('#infoAlert').find('.response-message').addClass('alert-success');
          $('#infoAlert').find('.response-message').html(response.data.message);
          $("#infoAlert").show();

          if(response.data.location){            
              window.setTimeout(function(){window.location.href=response.data.location}, 1300);
          }
                      
        }
      });
    });

    //changed syntax that equates to $('document').ready()
    $(function() { 

      if ($('#selectStepOne').hasClass('active') && $('#selectStepZero').hasClass('active')) {
        $('#selectStepOne').hide();
      }
    });

    $("#stepOneButtonBack").on('click', function(){
       $('#selectStepOne').hide();
       $('#selectStepZero').show();
    });

    $("#stepThreeButtonBack").on('click', function(){
      $('#selectStepOne').show();
      $('#selectStepThree').hide();
      $("#mainDateDiv").addClass('d-none');
    });

    //first responders opening checkbox
    $("#first_responder_opening_checkbox").on('change', function() {
      if($(this).is(":checked")){
        $(".first_responder_reasons").removeClass('d-none')
      }
      else{
        $(".first_responder_reasons").addClass('d-none')
        $(".first_responder_reason").prop('checked', false);
      }
    })
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/online-course-enrolment.js